import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function ellipsis(text: string, maxLength: number = 20) {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
}
